import React, { ReactNode } from "react";
import { Flex, Spinner, Td, Tr, Heading, Text } from "@chakra-ui/react";

interface TableLoaderProps {
  loader: boolean;
  show: number;
  noDataText?: string;
  children: ReactNode;
}

const TableLoader: React.FC<TableLoaderProps> = ({
  loader,
  show,
  noDataText,
  children,
}) => {
  if (loader) {
    return (
      <Tr>
        <Td colSpan={10} p={5}>
          <Flex justifyContent="center">
            <Spinner
              color="teal"
              size="lg"
              thickness="3px"
              emptyColor="gray.200"
            />
          </Flex>
        </Td>
      </Tr>
    );
  }

  if (show === 0) {
    return (
      <Tr>
        <Td colSpan={10} p={5}>
          <Flex justifyContent="center">
            <Text fontSize="sm">
              {noDataText ? noDataText : "No Data Available to Show"}
            </Text>
          </Flex>
        </Td>
      </Tr>
    );
  }

  return <>{children}</>;
};

export default TableLoader;
